import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Energia from "./pages/Energia";
import Fotovoltaico from "./pages/Fotovoltaico";
import Carregamento from "./pages/Carregamento";
import Agua from "./pages/Agua";
import Elevadores from "./pages/Elevadores";
import Perfil from "./pages/Perfil";
import PostosList from "./pages/PostosList";
import PostoDetalhe from "./pages/PostoDetalhe";
import UtilizadoresList from "./pages/UtilizadoresList";
import UtilizadorDetalhe from "./pages/UtilizadorDetalhe";
import MapaPostos from "./pages/MapaPostos";
import Alertas from "./pages/Alertas";
import ConfiguracaoAgua from "./pages/ConfiguracaoAgua";
import ConfiguracaoFotovoltaico from "./pages/ConfiguracaoFotovoltaico";
import ConfiguracaoElevadores from "./pages/ConfiguracaoElevadores";
import ConfiguracaoEnergia from "./pages/ConfiguracaoEnergia";
import { Toaster } from "./components/ui/sonner";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">A carregar...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <AlertProvider>
        <BrowserRouter>
          <Toaster />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="energia" element={<Energia />} />
              <Route path="fotovoltaico" element={<Fotovoltaico />} />
              <Route path="carregamento" element={<Carregamento />} />
              <Route path="carregamento/mapa" element={<MapaPostos />} />
              <Route path="carregamento/postos" element={<PostosList />} />
              <Route path="carregamento/postos/:id" element={<PostoDetalhe />} />
              <Route path="carregamento/utilizadores" element={<UtilizadoresList />} />
              <Route path="carregamento/utilizadores/:id" element={<UtilizadorDetalhe />} />
              <Route path="agua" element={<Agua />} />
              <Route path="elevadores" element={<Elevadores />} />
              <Route path="perfil" element={<Perfil />} />
              <Route path="configuracoes/alertas" element={<Alertas />} />
              <Route path="configuracoes/agua" element={<ConfiguracaoAgua />} />
              <Route path="configuracoes/fotovoltaico" element={<ConfiguracaoFotovoltaico />} />
              <Route path="configuracoes/elevadores" element={<ConfiguracaoElevadores />} />
              <Route path="configuracoes/energia" element={<ConfiguracaoEnergia />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AlertProvider>
    </AuthProvider>
  );
}

export default App;
